export const generateRandomPassword = (regex: RegExp): string => {
    const length = 8
    const allowedChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=[]{}|;:,.<>?'
    let password: string

    do {
        password = ''

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * allowedChars.length)
            password += allowedChars[randomIndex]
        }
    } while (!regex.test(password))

    return password
}
